<template>
    <div class="motai" v-show="isShow">
        <p class="message">{{ message }}</p>
        <p class="close" @click="$emit('click')">ok</p>
      </div>
</template>
<script>
export default {
    name:"Motail",
    data(){
        return{}
    },
    props:['message','isShow']
}
</script>
<style scoped>
.invite .invite_bgup .motai {
  position: fixed;
  top: 90%;
  left: 23%;
  width: 10rem;
  height: 5rem;
  background-color: rgba(0, 0, 0, 0.5);
  top: 50%;
  border-radius: 0.5rem;
  z-index: 9999;
}
.invite .invite_bgup .message {
  color: white;
  font-size: 0.75rem;
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
  border-bottom: 0.025rem solid gray;
}
.invite .invite_bgup .close {
  color: white;
  font-size: 1rem;
  width: 100%;
  height: 2.5rem;
  line-height: 2.5rem;
}
</style>





// WEBPACK FOOTER //
// src/Component/Motial.vue